import { render, staticRenderFns } from "./HighExpenseInsight.vue?vue&type=template&id=7c4d2634&scoped=true"
import script from "./HighExpenseInsight.vue?vue&type=script&lang=js"
export * from "./HighExpenseInsight.vue?vue&type=script&lang=js"
import style0 from "./HighExpenseInsight.vue?vue&type=style&index=0&id=7c4d2634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4d2634",
  null
  
)

export default component.exports